module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    attrs: {
      "inset": ""
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": item.action
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      class: [item.iconClass]
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.subtitle))])], 1)], 1)
  }), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', {
    staticClass: "grey lighten-1 white--text"
  }, [_vm._v("camera")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Camera Quality")]), _vm._v(" "), _c('v-slider', {
    staticClass: "px-3",
    attrs: {
      "min": "20",
      "thumb-label": "",
      "step": "10",
      "ticks": ""
    },
    model: {
      value: (_vm.cameraQuality),
      callback: function($$v) {
        _vm.cameraQuality = $$v
      },
      expression: "cameraQuality"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    attrs: {
      "inset": ""
    }
  }, [_vm._v("Job Queue")]), _vm._v(" "), _vm._l((_vm.jobQueueArray), function(job) {
    return _c('v-list-tile', {
      key: job
    }, [_c('v-list-tile-avatar'), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n            Job Number : " + _vm._s(_vm.jobQueue[job].JobNo) + "\n          ")])], 1)
  })], 2)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cea9747e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 679
// module chunks = 1